<gp-modal [closable]="true" size="xl" [onSubmit]="submitCallback">
  <div class="gp-modal-title">
    <h4 class="text-ellipsis">
      {{'PAYROLL_TESTING.hawk_test' | translate}}
    </h4>
  </div>
  <div class="gp-modal-body">
    <form novalidate [formGroup]="hawkTestCreationForm">
      <div class="row">
        <div class="col-md-6 form-group-sm form-group-sm">
          <label class="font-weight-bold">{{ 'PAYROLL_TESTING.contract_id' | translate }}:</label>
          <span class="form-control">{{ hawkTestCreationForm.get('contractId').value }}</span>
        </div>
        <div class="col-md-6 form-group-sm">
          <label class="font-weight-bold">{{ 'PAYROLL_TESTING.cli_reg_id' | translate }}:</label>
          <span class="form-control">{{ hawkTestCreationForm.get('cliRegId').value }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 form-group-sm">
          <label class="font-weight-bold">{{ 'PAYROLL_TESTING.suite' | translate }}:</label>
          <input type="text" class="form-control" placeholder="{{ 'PAYROLL_TESTING.suite_placeholder' | translate }}"
                 [formControlName]="'suite'">
        </div>
        <div class="col-md-6 form-group-sm">
          <label class="font-weight-bold">{{ 'PAYROLL_TESTING.feature' | translate }}:</label>
          <input type="text" class="form-control" placeholder="{{ 'PAYROLL_TESTING.feature_placeholder' | translate }}"
                 [formControlName]="'feature'">
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 form-group-sm">
          <div>
            <label class="font-weight-bold">{{ 'PAYROLL_TESTING.labels' | translate }}</label>
            <gp-chips class="form-control form-control-xl"
                      [placeholder]="'PAYROLL_TESTING.choose_labels'"
                      [formControlName]="'labels'"
                      [modelAsString]="true"
                      [canAddNewTags]="true">
            </gp-chips>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 form-group-sm">
          <label class="font-weight-bold">{{ 'PAYROLL_TESTING.title' | translate }}</label>
          <input type="text" class="form-control" placeholder="{{ 'PAYROLL_TESTING.title_placeholder' | translate }}"
                 [formControlName]="'title'">
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 form-group-sm">
          <label class="font-weight-bold">{{ 'PAYROLL_TESTING.description' | translate }}</label>
          <textarea [formControlName]="'description'" class="textarea-control"
                    placeholder="{{ 'PAYROLL_TESTING.description_placeholder' | translate }}"
                    rows="5"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 form-group-sm">
          <label class="font-weight-bold">{{ 'PAYROLL_TESTING.assertion_selector' | translate }}</label>
          <gp-chips class="form-control form-control-xl"
                    [placeholder]="'PAYROLL_TESTING.assertion_placeholder'"
                    [withAutocomplete]="true"
                    [formControlName]="'rules'"
                    [canAddNewTags]="false"
                    [modelAsString] = "true"
                    (filterOptions)="filterPayRulesBasedOnInput($event)">
            <gp-chips-option *ngFor="let option of rules" [ngValue]="option"></gp-chips-option>
          </gp-chips>
        </div>
      </div>
      <div class="row">
        <gp-table class="col-md-12 table-condensed">
          <thead>
          <tr class="row">
            <th id="hawk-computed-date" class="column-title col-md-2" gp-table-column>
              {{ 'PAYROLL_TESTING.computed_date' | translate }}
            </th>
            <th id="hawk-begin-date" class="column-title col-md-2" gp-table-column>
              {{ 'COMMON.beginDate' | translate }}
            </th>
            <th id="hawk-end-date" class="column-title col-md-2" gp-table-column>
              {{ 'COMMON.endDate' | translate }}
            </th>
            <th id="hawk-assertions" class="column-title col-md-6" gp-table-column>
              {{ 'PAYROLL_TESTING.assertions' | translate }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr *ngIf="payExecsLoading" class="row">
            <td colspan="5" class="text-center p-t-lg p-b-lg col-md-12">
              <em class="fa fa-light fa-spinner fa-spin"></em>
            </td>
          </tr>
          <tr *ngIf="!payExecsLoading && !hawkExecutions?.length" class="row">
            <td colspan="5" class="text-center p-t-lg p-b-lg col-md-12">
              {{ 'PAYROLL_TESTING.no_executions' | translate }}
            </td>
          </tr>
          <ng-container *ngIf="!payExecsLoading && hawkExecutions?.length" formArrayName="executions">
            <ng-container *ngFor="let exec of executions.controls; let executionIndex = index">
              <tr [formGroup]="execution(executionIndex)" class="row">
                <td class="col-md-2">
                  <span>{{ execution(executionIndex).get('executionDate').value | gpDate:{withTime: true} }}</span>
                </td>
                <td class="col-md-2">
                  <span>{{ execution(executionIndex).get('beginDate').value | gpDate }}</span>
                </td>
                <td class="col-md-2">
                  <span>{{ execution(executionIndex).get('endDate').value | gpDate }}</span>
                </td>
                <td class="col-md-6 table-wrapper">
                  <table class="table-condensed w-full" aria-label="assertions table">
                    <thead class="white">
                    <tr class="row">
                      <th class="col-md-8">
                        {{ 'PAYROLL_TESTING.assertion_label_name' | translate }}
                      </th>
                      <th class="col-md-3">
                        {{ 'PAYROLL_TESTING.assertion_label_value' | translate }}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <ng-container [formGroup]="this.assertions(executionIndex)">
                      <ng-container *ngFor="let assertionName of this.assertions(executionIndex).controls | keys">
                        <tr *ngIf="assertionName !== '__edit_mode__'"
                            class="row">
                          <td class="col-md-8"><span id="name">{{assertionName}}</span></td>
                          <td class="col-md-3">
                            <input id="value"
                                   class="form-control"
                                   type="number"
                                   [formControlName]="assertionName"/>
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                    </tbody>
                  </table>
                </td>
              </tr>
            </ng-container>
          </ng-container>
          </tbody>
        </gp-table>
      </div>
    </form>
  </div>
</gp-modal>
